import _ from 'lodash'
export default class Queue {
	/**
 	* @param { Function(Array[Number]) Map<Number,Object> } resolver
 	*/
	constructor(resolver) {
		this.idList = []
		this.waitList = []
		this.resolver = resolver
		this._fetch=_.debounce(this.fetch,10)
	}
	get(id) {
		this._fetch()
		this.idList.push(id)
		var p = new Promise((resolve, reject) => {
			this.waitList.push({
				id,
				resolve,
				reject
			})
		})
		return p
	}
	fetch() {
		var idList = _.uniq(this.idList)
		var waitList = this.waitList
		this.idList = []
		this.waitList = []
		if(!idList.length)return
		_.chunk(idList,20).forEach(async(idListChunk)=>{
			try {
				var pool = await this.resolver(idListChunk)
				waitList.forEach(waiter => {
					let id = waiter.id
					if(!pool[id]){
						return
					}
					waiter.resolve(pool[id])
				})
			} catch (err) {
				waitList.forEach(waiter => {
					waiter.reject(err)
				})
			}
		})
	}
}


export class CacheRequest {
	/**
 	* @param { Function(any) any } resolver
 	*/
	constructor(resolver) {
		this.waitList = []
		this.resolver = resolver
	}
	get(...args) {
		if(this.error){
			throw new Error(this.error)
		}
		if (this.result !== undefined) {
			return this.result
		}
		var p = new Promise((resolve, reject) => {
			this.waitList.push({
				resolve,
				reject
			})
		})
		this.fetch(args)
		return p
	}
	async fetch(args) {
		if(this.loading)return
		this.loading=true
		try {
			this.result = await this.resolver(...args)
			this.waitList.forEach(waiter => {
				waiter.resolve(this.result)
			})
		} catch (err) {
			this.error=err
			this.waitList.forEach(waiter => {
				waiter.reject(err)
			})
		}
		this.loading=false
	}
}

export class SplitQueue {
	constructor(resolver,maxSize) {
		this.resolver = resolver
		this.maxSize=maxSize
	}
	async fetch(arr,isObject) {
		arr=_.uniq(arr)
		let chunks = _.chunk(arr, this.maxSize)
		let requests = []
		for (let i = 0; i < chunks.length; i++) {
			requests.push(this.resolver(chunks[i]))
		}
		let data = await Promise.all(requests)
		return isObject?data.reduce((a,b)=>({...a,...b}),{}):_.flatten(data)
	}
}